import { render } from "./EspeMedi.vue?vue&type=template&id=081339b6&scoped=true"
import script from "./EspeMedi.vue?vue&type=script&lang=js"
export * from "./EspeMedi.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=081339b6&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081339b6"]])

export default __exports__